const TOKEN_KEY = "auth_token";

const safeWindow = typeof window !== "undefined" ? window : undefined;

const getStorage = () => {
  if (!safeWindow) {
    return undefined;
  }
  return safeWindow.localStorage;
};

const getSessionStorage = () => {
  if (!safeWindow) {
    return undefined;
  }
  return safeWindow.sessionStorage;
};

const secureStorage = {
  setItem(key, value) {
    const storage = getStorage();
    if (storage) {
      storage.setItem(key, value);
    }
  },
  getItem(key) {
    const storage = getStorage();
    if (!storage) {
      return null;
    }

    return storage.getItem(key);
  },
  removeItem(key) {
    const storage = getStorage();
    if (storage) {
      storage.removeItem(key);
    }
  },
  setJson(key, value) {
    secureStorage.setItem(key, JSON.stringify(value));
  },
  getJson(key) {
    const raw = secureStorage.getItem(key);
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      console.error("Failed to parse storage value", error);
      return null;
    }
  },
  clearJson(key) {
    secureStorage.removeItem(key);
  },
  setToken(token) {
    const storage = getSessionStorage();
    if (storage) {
      storage.setItem(TOKEN_KEY, token);
    }
  },
  getToken() {
    const storage = getSessionStorage();
    if (!storage) {
      return null;
    }

    return storage.getItem(TOKEN_KEY);
  },
  removeToken() {
    const storage = getSessionStorage();
    if (storage) {
      storage.removeItem(TOKEN_KEY);
    }
  },
  clearAuth() {
    secureStorage.removeToken();
  },
};

export default secureStorage;
